export enum UNLINKED_EXACT_LICENSES_STORAGE_KEYS {
  IgnoredUnlinkedExactLicensesPreference = "ignored-unlinked-exact-licenses-preference",
  ExactCategoryTypesPreference = "exact-category-types-preference"
}
